import React from 'react';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import { useLanguage } from '@/contexts/LanguageContext';

interface AntdLocaleProviderProps {
  children: React.ReactNode;
}

const AntdLocaleProvider: React.FC<AntdLocaleProviderProps> = ({ children }) => {
  const { isEnglish } = useLanguage();

  return <ConfigProvider locale={isEnglish ? enUS : zhCN}>{children}</ConfigProvider>;
};

export default AntdLocaleProvider;
